"use strict";var e=require("react");require("clsx");const t=e.createContext(null);exports.ThemeContext=t,exports.useTheme=()=>e.useContext(t);
